import { isVNode as E, createVNode as y, render as T } from "vue";
import A from "./index758.js";
import { messageTypes as _, MESSAGE_DEFAULT_PLACEMENT as m, messageDefaults as b, messagePlacement as M } from "./index693.js";
import { getOrCreatePlacementInstances as P, placementInstances as p } from "./index759.js";
import { messageConfig as t } from "./index619.js";
import { isString as g, isFunction as d, hasOwn as w } from "./index575.js";
import { isNumber as u, isElement as N, isBoolean as f } from "./index565.js";
import { debugWarn as v } from "./index588.js";
import { isClient as O } from "./index599.js";
let F = 1;
const S = (e) => {
  if (!e.appendTo)
    e.appendTo = document.body;
  else if (g(e.appendTo)) {
    let n = document.querySelector(e.appendTo);
    N(n) || (v(
      "ElMessage",
      "the appendTo option is not an HTMLElement. Falling back to document.body."
    ), n = document.body), e.appendTo = n;
  }
}, B = (e) => {
  !e.placement && g(t.placement) && t.placement && (e.placement = t.placement), e.placement || (e.placement = m), M.includes(e.placement) || (v(
    "ElMessage",
    `Invalid placement: ${e.placement}. Falling back to '${m}'.`
  ), e.placement = m);
}, x = (e) => {
  const o = !e || g(e) || E(e) || d(e) ? { message: e } : e, n = {
    ...b,
    ...o
  };
  return S(n), B(n), f(t.grouping) && !n.grouping && (n.grouping = t.grouping), u(t.duration) && n.duration === 3e3 && (n.duration = t.duration), u(t.offset) && n.offset === 16 && (n.offset = t.offset), f(t.showClose) && !n.showClose && (n.showClose = t.showClose), f(t.plain) && !n.plain && (n.plain = t.plain), n;
}, D = (e) => {
  const o = e.props.placement || m, n = p[o], s = n.indexOf(e);
  if (s === -1) return;
  n.splice(s, 1);
  const { handler: i } = e;
  i.close();
}, I = ({ appendTo: e, ...o }, n) => {
  const s = `message_${F++}`, i = o.onClose, c = document.createElement("div"), l = {
    ...o,
    // now the zIndex will be used inside the message.vue component instead of here.
    // zIndex: nextIndex() + options.zIndex
    id: s,
    onClose: () => {
      i?.(), D(C);
    },
    // clean message element preventing mem leak
    onDestroy: () => {
      T(null, c);
    }
  }, a = y(
    A,
    l,
    d(l.message) || E(l.message) ? {
      default: d(l.message) ? l.message : () => l.message
    } : null
  );
  a.appContext = n || r._context, T(a, c), e.appendChild(c.firstElementChild);
  const h = a.component, C = {
    id: s,
    vnode: a,
    vm: h,
    handler: {
      // instead of calling the onClose function directly, setting this value so that we can have the full lifecycle
      // for out component, so that all closing steps will not be skipped.
      close: () => {
        h.exposed.close();
      }
    },
    props: a.component.props
  };
  return C;
}, r = (e = {}, o) => {
  if (!O) return { close: () => {
  } };
  const n = x(e), s = P(
    n.placement || m
  );
  if (n.grouping && s.length) {
    const c = s.find(
      ({ vnode: l }) => {
        var a;
        return ((a = l.props) == null ? void 0 : a.message) === n.message;
      }
    );
    if (c)
      return c.props.repeatNum += 1, c.props.type = n.type, c.handler;
  }
  if (u(t.max) && s.length >= t.max)
    return { close: () => {
    } };
  const i = I(n, o);
  return s.push(i), i.handler;
};
_.forEach((e) => {
  r[e] = (o = {}, n) => {
    const s = x(o);
    return r({ ...s, type: e }, n);
  };
});
function L(e) {
  for (const o in p)
    if (w(p, o)) {
      const n = [...p[o]];
      for (const s of n)
        (!e || e === s.props.type) && s.handler.close();
    }
}
function $(e) {
  if (!p[e]) return;
  [...p[e]].forEach((n) => n.handler.close());
}
r.closeAll = L;
r.closeAllByPlacement = $;
r._context = null;
export {
  L as closeAll,
  $ as closeAllByPlacement,
  r as default
};
